export default __webpack_public_path__ + "static/media/tlou_main.6a528098.mp4";